import { render } from "./MenuContentItem.vue?vue&type=template&id=57ed4227"
import script from "./MenuContentItem.vue?vue&type=script&lang=js"
export * from "./MenuContentItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__